import React, { useEffect, useState } from 'react';
import { translate } from '../Services/translation';
import { useDispatch, useSelector } from 'react-redux';
import {
    deleteWishlist,
    getAllWishlists,
    setIsInWishlist,
    setIncludedInWishlists,
} from '../Actions/Wishlist.action';

const WishlistOverview = ({
    edit,
    onUpdateActiveList,
    onUpdateWishlistName,
}) => {
    const [editCurrentName, setEditCurrentName] = useState('');
    const [editNewName, setEditNewName] = useState('');
    const [handleEdit, setHandleEdit] = useState(edit);
    const { lists, includedInWishlists } = useSelector(
        (state) => state.wishlist
    );
    const wishlist = useSelector((state) => state.wishlist);
    const dispatch = useDispatch();

    useEffect(() => {
        setHandleEdit(edit);
    }, [edit, includedInWishlists]);

    function updateEditWishlist(evt) {
        const val = evt.target.value;
        setEditNewName(val);
    }

    function handleGoToList(listName) {
        onUpdateActiveList(listName);
    }

    function handleEditList(listName) {
        setHandleEdit(true);
        setEditCurrentName(listName);
        setEditNewName(listName);
    }

    function handleUpdateWishlistName() {
        onUpdateWishlistName(editCurrentName, editNewName);
    }

    function handleDeleteList(listName) {
        dispatch(deleteWishlist(listName)).then(() => {
            const updatedIncludedInWishlists = includedInWishlists.filter(
                (item) => item !== listName
            );
            if (updatedIncludedInWishlists.length === 0) {
                dispatch(setIsInWishlist(false));
            }
            dispatch(setIncludedInWishlists(updatedIncludedInWishlists));
            dispatch(getAllWishlists());
        });
    }

    return (
        <div className="wishlist-overview__container" key={edit}>
            {lists && Object.keys(lists).length < 1 && (
                <div className="wishlist-overview__empty">
                    <p>{translate('wishlist.nowishlist')}</p>
                </div>
            )}
            {handleEdit && (
                <div className="wishlist-overview__edit">
                    <input
                        className="form__input"
                        id="wishlist-name"
                        name="name"
                        type="text"
                        value={editNewName}
                        onChange={(evt) => updateEditWishlist(evt)}
                    />
                    <div className="wishlist-overview__button-wrapper">
                        <button
                            type="submit"
                            className="button button--cancel"
                            onClick={() => {
                                handleDeleteList(editCurrentName);
                                setHandleEdit(false);
                            }}
                        >
                            {translate('wishlist.delete')}
                        </button>
                        <button
                            type="submit"
                            className="button button--submit"
                            onClick={() => {
                                handleUpdateWishlistName();
                                setHandleEdit(false);
                            }}
                        >
                            {translate('wishlist.save')}
                        </button>
                    </div>
                </div>
            )}

            {!handleEdit &&
                wishlist &&
                Object.values(lists).map((item, index) => (
                    <div
                        key={`wishlist-overview-list-item-${index}`}
                        className="wishlist-overview__item"
                    >
                        <p className="wishlist-overview__text">{item.name}</p>
                        <div className="wishlist-overview__handle-list">
                            <a
                                className="wishlist-overview__edit-button"
                                onClick={() => handleEditList(item.name)}
                                title={translate('edit')}
                            ></a>
                            <a
                                className="wishlist-overview__delete-button"
                                onClick={() => handleDeleteList(item.name)}
                                title={translate('delete')}
                            ></a>
                        </div>
                        <a
                            className="wishlist-overview__chevron-button"
                            onClick={() => handleGoToList(item.name)}
                            title={translate('wishlist.gotolist')}
                        ></a>
                    </div>
                ))}
        </div>
    );
};

export default WishlistOverview;
